import type { CheckboxProps } from "@mui/material";
import { CheckboxV2 } from "src/components/CheckboxV2/CheckboxV2.tsx";
import React from "react";

export const DataGridCheckbox = (props: CheckboxProps) => {
  const { onChange, inputRef, checked, disabled, name, onClick } = props;

  return (
    <CheckboxV2
      disabled={disabled}
      checked={checked}
      name={name}
      onChange={(e) => onChange?.(e, e.currentTarget.checked)}
      onClick={(e) => {
        // the onClick event is used in the column management panel to toggle column visibility
        // if you remove the onClick handler then the checkbox won't toggle
        // I don't know why MUI developers didn't use the onChange event for this

        onClick?.(
          // @ts-ignore
          e,
        );
      }}
      ref={inputRef}
    />
  );
};
